class CompareProducts extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll('.compare-product__item');
  }

  connectedCallback() {
    const handleResize = () => {
        const bwidth = this.offsetWidth - this.items.length * 152;
        const borderWidth = bwidth > 0? bwidth + 142 : 152;
        this.items.forEach(item => {
            item.querySelectorAll('.compare-product__item-compare').forEach(_item => {
                _item.style.setProperty('--border-width', `${borderWidth}px`);
            });
        });

        const selectors = [
            '.compare-product__item-image',
            '.compare-product__item-title',
            '.compare-product__item-compare-1',
            '.compare-product__item-compare-2',
            '.compare-product__item-compare-3'
        ];

        selectors.forEach(selector => {
            const elements = this.querySelectorAll(selector);
            if (!elements.length) return;

            // Reset height first
            elements.forEach(el => (el.style.height = 'auto'));

            // Get max height
            const maxHeight = Math.max(...Array.from(elements).map(el => el.offsetHeight));

            // Apply uniform height
            elements.forEach(el => {
            el.style.height = `${maxHeight}px`;
            });
        });
    };

    // Run once when connected
    handleResize();

    // Run again on resize
    window.addEventListener('resize', handleResize, { passive: true });

    // Optional: re-run after images load
    window.addEventListener('load', handleResize);
  }
}

if (!customElements.get('compare-products')) {
  customElements.define('compare-products', CompareProducts);
}
